<template>

    <div class="container">
        <div class="padding">
            <h3 class="red">We haven't been able to match your file<br> to one of our products.</h3>
        </div>

        <div class="padding">
            <p>We're unable to support this combination of size and pages:</p>
        <div class="padding centerContainer textAlignCenter">
            <p>{{pdf}}</p>
            <div class="textAlignCenter">
                {{printJob.printJobSpec.pageCount}} pages | {{printJob.printJobSpec.pageWidth}}mm x
                {{printJob.printJobSpec.pageHeight}}mm | {{printJob.printJobSpec.pageOrientation}}
            </div>
        </div>
        </div>

        <div class="padding">
            <p>Please contact our team who will be happy to review your template<br> and enable you to print with
                us.</p>
            <div class="paddingTopSmall">
                <p>Ravensworth Client Services:</p>
                <p class="teal">0191 917 9331</p>
                <p class="teal">client.support@ravensworth.co.uk</p>
            </div>
        </div>

        <div class="padding">
            <p>Please close this window</p>
        </div>
    </div>

</template>

<script>

    export default {
        name: "noproducts",
        components: {},
        props: {
            printJob: {}
        },
        data() {
            return {
                pdf: ''
            }
        },
        created() {
            this.pdf = window.sessionStorage.getItem('_filename')
        },
        methods: {
        }
    };
</script>